import {CustomCode} from "../../../model/common.model";

export class SchedulePrintConfig {
    employeeId: string;
    ordering = SortOrderType.ALPHABETICAL;
    showHeader = true;
    showOtherDiv = false;
    showNoSchedule = false;
    showDivision = true;
    showJob = true;
    showFunction = true;
    showMeal = true;
    showBreak = true;
    showTraining = true;
    showTimeOff = true;
    showColor = true;
    showTel = true;
    showTotal = true;
    showShiftTotal = true;
    showDailyPercentage = false;
    showTasks = false;
    showWorkShiftBonus = false;


  _createSpecialElement(propertyName: string, data: any) {
    if ('ordering' === propertyName) {
      this.ordering = SortOrderType.retrieveFromCode(data);
      return true;
    }
    return false;
  }

}



export class SortOrderType extends CustomCode {
  private static _registered = new Map<string, SortOrderType>();
  static SENIORITY = new SortOrderType('SENIORITY');
  static PREDEFINED_SORT_ORDER = new SortOrderType('PREDEFINED_SORT_ORDER');
  static EMPLOYE_ID = new SortOrderType('EMPLOYE_ID');
  static ALPHABETICAL = new SortOrderType('ALPHABETICAL');
  static DEFAULT_JOB = new SortOrderType('DEFAULT_JOB');
  static SCREEN_ORDER = new SortOrderType('SCREEN_ORDER');
  static ECHELON_LEVEL= new SortOrderType('ECHELON_LEVEL');

  static ALL = Array.from(SortOrderType._registered.values());
  static NORMAL = [SortOrderType.ALPHABETICAL,SortOrderType.EMPLOYE_ID,SortOrderType.PREDEFINED_SORT_ORDER,SortOrderType.SENIORITY,SortOrderType.SCREEN_ORDER];
  static NORMAL_ECHELON = [SortOrderType.ALPHABETICAL,SortOrderType.EMPLOYE_ID,SortOrderType.PREDEFINED_SORT_ORDER,SortOrderType.SENIORITY,SortOrderType.SCREEN_ORDER,SortOrderType.ECHELON_LEVEL];

  static retrieveFromCode(code: string): SortOrderType {
    const res = SortOrderType._registered.get(code);
    if (!res) {
      console.log('Hmmm SortOrderType can\'t find ' + code);
    }
    return res;
  }

  constructor(code: string ) {
    super(code);
    SortOrderType._registered.set(code, this);
  }


  public toString(): string {
    return this.code;
  }


  public toTranslateKey(): string{
    return 'SORT_ORDER_' + this.code;
  }
}

export class HourFormatType extends CustomCode {
  private static _registered = new Map<string, HourFormatType>();

  static HOUR_24 = new HourFormatType('HOUR_24');
  static HOUR_AM_PM = new HourFormatType('HOUR_AM_PM');


  static ALL = Array.from(HourFormatType._registered.values());

  static retrieveFromCode(code: string): HourFormatType {
    const res = HourFormatType._registered.get(code);
    if (!res) {
      console.log('Hmmm HourFormatType can\'t find ' + code);
    }
    return res;
  }

  constructor(code: string ) {
    super(code);
    HourFormatType._registered.set(code, this);
  }


  public toString(): string {
    return this.code;
  }


  public toTranslateKey(): string{
    return 'HOUR_FORMAT_' + this.code;
  }
}
